import React = require("react");
import {shouldQuestionBeVisible} from "../FeebackService";
import {FormAnswers, FormQuestion, FormQuestionAnswer} from "../FeedbackFormModel";
import {FormEntityUI} from "./FormEntityUI";
import {Display} from "../../components/Display";

interface Props {
    questions: FormQuestion[];
    className?: string;
    entityClassName?: string;
    onChange?: (answers: FormAnswers) => void;
}

interface State {
    formAnswers: FormQuestionAnswer[];
}

export class FormBuilder extends React.Component<Props, State> {

    constructor(props) {
        super(props);
        this.state = {
            formAnswers: [],
        };
    }

    public render() {
        return (
            <div className={this.props.className}>
                {this.props.questions.map((entity) => (
                    <Display
                        key={entity.guid}
                        isVisible={shouldQuestionBeVisible(entity, this.state.formAnswers)}
                    >
                        <div className={this.props.entityClassName}>
                            <FormEntityUI
                                entity={entity}
                                onChange={this.onAnswerChange}
                            />
                        </div>
                    </Display>
                ))}
            </div>
        );
    }

    private onAnswerChange = (newAnswer: FormQuestionAnswer) => {

        this.setState({
            formAnswers: [
                ...this.state.formAnswers.filter((x) => x.questionGuid !== newAnswer.questionGuid),
                newAnswer,
            ].filter((x, _, self) =>
                shouldQuestionBeVisible(
                    this.props.questions.find((question) => question.guid === x.questionGuid),
                    self,
                ),
            ),
        }, () => {
            if (!this.props.onChange) {
                return;
            }

            this.props.onChange({
                questions: this.state.formAnswers,
            });
        });
    }
}
